



























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Moment from "moment-timezone";
import PageRequest from "@/store/entities/page-request";

class PageUserRequest extends PageRequest {
    id: string;
    keyword: string;
    startTime: string;
    endTime: string;
    state: number;
    sortBy: string;
    desceding: boolean;
    tenantId: number;
}

@Component({
    components: {},
})
export default class DeleteWaringMessage extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    loading: boolean = false;
    pagerequest: PageUserRequest = new PageUserRequest();
    spinShow: boolean = false;//加载状态

    create() { }
    created() {
        this.pagerequest.startTime = Moment()
            .add(-7, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.endTime = Moment()
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
    }
    changdate(val) {
        if (val.length > 1) {
            this.pagerequest.startTime = val[0];
            this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
                .endOf("day")
                .format("YYYY-MM-DD HH:mm:ss");
        }
    }
    async save() {
        this.spinShow = true;
        let res = await this.$store.dispatch({
            type: "devicewaring/delete",
            data: this.pagerequest,
        }).catch((err) => {
            this.spinShow = false;
            this.$Modal.error({
                title: this.L("Tips"),
                content: err,
            });
        });
        this.spinShow = false;
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    data() {
        return {
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
        };
    }
}
